import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function changePassword(userid: number, newPassword: string): Promise<boolean | string> {
    if (!api.userApi) {
        return false;
    }

    return api.userApi.usersChangepassword(userid, newPassword).then((response) => {
        if (response instanceof Error || (response.message && response.message.error)) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response);
            } else {
                store.doNotice(lang[response.message.error]);
            }

            return false;
        }

        return true;
    });
}

export { changePassword };
